/* =========================================================================
   EasyPets · Easy Puppy Gids — interactive hub
   Drives the featured player, the "leerlijn" (per-week) view, the filterable
   grid, the share buttons, the opt-in form and the pet sign-up wizard.

   Episodes come from a JSON <script id="ep-gids-data"> emitted by the
   afleveringen section (built from theme-editor blocks). Everything is
   null-guarded so each section works whether or not the others are present.
   ========================================================================= */
(function () {
  "use strict";
  if (window.__epGidsInit) return;
  window.__epGidsInit = true;

  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  function ready(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn, { once: true });
    } else {
      fn();
    }
  }

  function loadVideos() {
    const el = document.getElementById("ep-gids-data");
    if (!el) return [];
    try {
      const data = JSON.parse(el.textContent.trim());
      return Array.isArray(data) ? data : (data.videos || []);
    } catch (e) {
      console.warn("[ep-gids] kon afleveringen-data niet lezen:", e);
      return [];
    }
  }

  /* Per-week row labels (titel + sub). Editable defaults; matches design. */
  const WEEK_LABELS = {
    8:  ["Aankomst & de eerste dagen", "Het nieuwe gezinslid arriveert: rust, ritme en kennismaking."],
    9:  ["Bench, beten en het echte werk", "De pup test grenzen. Jij zet ze, zonder strijd."],
    10: ["Routine vinden", "Eten, plassen en slapen vallen op hun plek."],
    11: ["De wereld in", "Sociaal kennismaken met kinderen, geluiden, en het stoepje."],
    12: ["Klaar voor de volgende stap", "De pad uit, de wereld in."]
  };

  ready(function () {
    const VIDEOS = loadVideos();

    const grid = $("#video-grid");
    const leerlijnEl = $("#leerlijn-rows");
    const playerFrame = $("#player-frame");
    const npStepNum = $("#np-step-num");
    const npStepLabel = $("#np-step-label");
    const npTitle = $("#np-title");
    const npDesc = $("#np-desc");
    const npChips = $("#np-chips");
    const npProducts = $("#np-products");
    const npProductsGrid = $("#np-products-grid");

    /* =====================================================================
       SLOT / KLAVIYO GATE
       Aflevering(en) gratis, de rest op slot tot iemand zijn e-mail invult.
       Alle null-guarded: zonder #ep-gate-config gedraagt alles zich als vanouds.
       ===================================================================== */
    const GATE = (function () {
      const el = document.getElementById("ep-gate-config");
      const cfg = el ? {
        company: el.dataset.company || "",
        lists: (el.dataset.lists || "").split(",").map(s => s.trim()).filter(Boolean),
        freeCount: parseInt(el.dataset.freeCount || "1", 10),
        revision: el.dataset.revision || "2024-10-15",
        source: el.dataset.source || "puppy-gids",
        metric: el.dataset.metric || "Puppy gids toegangscode",
        props: (function () { try { return JSON.parse(el.dataset.props || "{}"); } catch (e) { return {}; } })()
      } : null;
      const freeCount = cfg && !isNaN(cfg.freeCount) ? cfg.freeCount : 1;
      const freeSlugs = new Set(VIDEOS.slice(0, freeCount).map(v => v.slug));
      const KEY = "ep_gids_unlocked";

      function unlocked() {
        try { if (localStorage.getItem(KEY) === "1") return true; } catch (e) {}
        return document.cookie.indexOf(KEY + "=1") !== -1;
      }
      function persistUnlock() {
        try { localStorage.setItem(KEY, "1"); } catch (e) {}
        try { document.cookie = KEY + "=1; path=/; max-age=31536000; samesite=lax"; } catch (e) {}
      }
      function configured() { return !!cfg && cfg.company && cfg.lists.length > 0; }
      function active() { return configured() && freeCount < VIDEOS.length; }
      function locked(v) { return active() && !unlocked() && !freeSlugs.has(v.slug); }

      function subscribe(email, extra) {
        extra = extra || {};
        if (!configured()) return Promise.reject(new Error("no-config"));
        const lists = (extra.lists && extra.lists.length) ? extra.lists : cfg.lists;
        const props = Object.assign({ source: cfg.source }, extra.properties || {});
        const src = extra.source || "Puppy gids";
        const calls = lists.map(function (listId) {
          return fetch("https://a.klaviyo.com/client/subscriptions/?company_id=" + encodeURIComponent(cfg.company), {
            method: "POST",
            headers: { "Content-Type": "application/json", revision: cfg.revision },
            body: JSON.stringify({
              data: {
                type: "subscription",
                attributes: {
                  custom_source: src,
                  profile: { data: { type: "profile", attributes: { email: email, properties: props } } }
                },
                relationships: { list: { data: { type: "list", id: listId } } }
              }
            })
          }).then(function (r) { return { ok: r.ok, status: r.status }; })
            .catch(function () { return { ok: false, status: 0 }; });
        });
        return Promise.all(calls).then(function (res) {
          if (res.some(function (x) { return x.ok; })) return true;
          return Promise.reject(new Error("klaviyo-failed"));
        });
      }

      /* Stuurt een Klaviyo-event (metric) met de toegangscode; een flow op deze
         metric mailt {{ event.code }} naar de bezoeker. */
      function fireEvent(email, code, extra) {
        extra = extra || {};
        if (!configured()) return Promise.reject(new Error("no-config"));
        const props = Object.assign({ code: code, source: cfg.source }, extra.properties || {});
        return fetch("https://a.klaviyo.com/client/events/?company_id=" + encodeURIComponent(cfg.company), {
          method: "POST",
          headers: { "Content-Type": "application/json", revision: cfg.revision },
          body: JSON.stringify({
            data: { type: "event", attributes: {
              metric: { data: { type: "metric", attributes: { name: cfg.metric } } },
              properties: props,
              profile: { data: { type: "profile", attributes: { email: email } } }
            } }
          })
        }).then(function (r) { if (r.ok) return true; return Promise.reject(new Error("event-failed")); })
          .catch(function () { return Promise.reject(new Error("event-failed")); });
      }

      return { cfg: cfg, unlocked: unlocked, persistUnlock: persistUnlock, active: active, locked: locked, subscribe: subscribe, fireEvent: fireEvent };
    })();

    /* =====================================================================
       GATE POPUP — 2-staps e-mailverificatie met code
       Stap 1: e-mail -> genereer code -> Klaviyo-event (flow mailt de code)
       Stap 2: code invullen -> klopt -> lijst-aanmelding + ontgrendelen
       ===================================================================== */
    const gateModal    = $("#ep-gate-modal");
    const gateStep1    = $("#ep-gate-step1");
    const gateStep2    = $("#ep-gate-step2");
    const gateSuccess  = $("#ep-gate-success");
    const gateForm     = $("#ep-gate-form");
    const gateEmail    = $("#ep-gate-email");
    const gateSubmit   = $("#ep-gate-submit");
    const gateHint     = $("#ep-gate-hint");
    const gateCodeForm = $("#ep-gate-code-form");
    const gateCode     = $("#ep-gate-code");
    const gateCodeSub  = $("#ep-gate-code-sub");
    const gateCodeHint = $("#ep-gate-code-hint");
    const gateResend   = $("#ep-gate-resend");
    const gateCodeSubTpl = gateCodeSub ? (gateCodeSub.getAttribute("data-template") || gateCodeSub.textContent) : "";

    // Lopende aanvraag: { email, code, slug, props, source, lists }
    let gatePending = null;

    function genCode() { return String(Math.floor(100000 + Math.random() * 900000)); }
    // Basis profiel-properties (bv. {"Heeft puppy":"yes"}) + extra
    function gateProps(extra) { return Object.assign({}, (GATE.cfg && GATE.cfg.props) || {}, extra || {}); }

    function showStep(n) {
      if (gateStep1) gateStep1.hidden = (n !== 1);
      if (gateStep2) gateStep2.hidden = (n !== 2);
      if (gateSuccess) gateSuccess.hidden = (n !== 3);
    }
    function revealModal() {
      if (!gateModal) {
        const sec = $("#optin-section") || document.getElementById("petsignup");
        if (sec) sec.scrollIntoView({ behavior: "smooth", block: "center" });
        return false;
      }
      gateModal.hidden = false;
      try { document.documentElement.style.overflow = "hidden"; } catch (e) {}
      return true;
    }
    function closeGate() {
      if (!gateModal) return;
      gateModal.hidden = true;
      try { document.documentElement.style.overflow = ""; } catch (e) {}
    }
    function unlockAndRefresh() {
      GATE.persistUnlock();
      renderLeerlijn();
      renderGrid();
    }

    // Stap 1 voor een vergrendelde video: toon e-mailstap
    function openGate(slug) {
      gatePending = { slug: slug || null, props: gateProps({ pet: "puppy" }), source: "Puppy gids popup", lists: null };
      if (!revealModal()) return;
      showStep(1);
      if (gateHint) gateHint.classList.remove("is-error");
      setTimeout(function () { if (gateEmail) gateEmail.focus(); }, 60);
    }

    // Verstuur de code en spring naar stap 2. opts: {props, source, slug, lists}
    function startCodeFlow(email, opts, btn) {
      opts = opts || {};
      const code = genCode();
      gatePending = {
        email: email, code: code,
        slug: opts.slug != null ? opts.slug : (gatePending && gatePending.slug) || null,
        props: opts.props || { pet: "puppy" },
        source: opts.source || "Puppy gids popup",
        lists: opts.lists || null
      };
      const orig = btn ? btn.textContent : "";
      if (btn) { btn.disabled = true; btn.textContent = "Bezig..."; }
      return GATE.fireEvent(email, code, { properties: gatePending.props })
        .then(function () {
          if (btn) { btn.disabled = false; btn.textContent = orig; }
          if (gateCodeSub) gateCodeSub.textContent = gateCodeSubTpl.replace("{email}", email);
          revealModal();
          showStep(2);
          if (gateCodeHint) gateCodeHint.classList.remove("is-error", "is-ok");
          if (gateCode) { gateCode.value = ""; setTimeout(function () { gateCode.focus(); }, 60); }
          return true;
        }, function (err) {
          if (btn) { btn.disabled = false; btn.textContent = orig; }
          throw err;
        });
    }

    if (gateModal) {
      $$("[data-gate-close]", gateModal).forEach(function (el) { el.addEventListener("click", closeGate); });
      document.addEventListener("keydown", function (e) { if (e.key === "Escape" && !gateModal.hidden) closeGate(); });
    }

    // Stap 1 submit
    if (gateForm) {
      if (gateEmail) gateEmail.addEventListener("input", function () { if (gateHint) gateHint.classList.remove("is-error"); });
      gateForm.addEventListener("submit", function (e) {
        e.preventDefault();
        const email = (gateEmail && gateEmail.value || "").trim();
        if (!email || (gateEmail && !gateEmail.checkValidity())) {
          if (gateEmail) gateEmail.focus();
          if (gateHint) { gateHint.classList.add("is-error"); gateHint.textContent = "Vul een geldig e-mailadres in."; }
          return;
        }
        startCodeFlow(email, { props: gateProps({ pet: "puppy" }), source: "Puppy gids popup" }, gateSubmit)
          .catch(function () {
            if (gateHint) { gateHint.classList.add("is-error"); gateHint.textContent = "Kon de code niet versturen. Probeer het zo nog eens."; }
          });
      });
    }

    // Stap 2 submit (code controleren)
    if (gateCodeForm) {
      if (gateCode) gateCode.addEventListener("input", function () { this.value = this.value.replace(/\D/g, "").slice(0, 6); if (gateCodeHint) gateCodeHint.classList.remove("is-error"); });
      gateCodeForm.addEventListener("submit", function (e) {
        e.preventDefault();
        if (!gatePending || !gatePending.code) return;
        const entered = (gateCode && gateCode.value || "").replace(/\D/g, "");
        if (entered !== gatePending.code) {
          if (gateCode) gateCode.focus();
          if (gateCodeHint) { gateCodeHint.classList.remove("is-ok"); gateCodeHint.classList.add("is-error"); gateCodeHint.textContent = "Die code klopt niet. Check je mail en probeer opnieuw."; }
          return;
        }
        // Code klopt: e-mail is geverifieerd -> aanmelden + ontgrendelen
        const codeSubmit = $("#ep-gate-code-submit");
        if (codeSubmit) codeSubmit.disabled = true;
        function finish() {
          unlockAndRefresh();
          showStep(3);
          const slug = gatePending && gatePending.slug;
          setTimeout(function () {
            closeGate();
            showStep(1);
            if (codeSubmit) codeSubmit.disabled = false;
            if (slug) playVideo(slug, true);
          }, 1500);
        }
        GATE.subscribe(gatePending.email, { lists: gatePending.lists, source: gatePending.source, properties: gatePending.props })
          .then(finish)
          .catch(function () { console.warn("[ep-gids] Klaviyo aanmelding mislukt (code was geldig)"); finish(); });
      });
    }

    // Code opnieuw versturen (zelfde code)
    if (gateResend) {
      gateResend.addEventListener("click", function () {
        if (!gatePending || !gatePending.email || !gatePending.code) return;
        gateResend.disabled = true;
        GATE.fireEvent(gatePending.email, gatePending.code, { properties: gatePending.props })
          .then(function () { if (gateCodeHint) { gateCodeHint.classList.remove("is-error"); gateCodeHint.classList.add("is-ok"); gateCodeHint.textContent = "Nieuwe code verstuurd, check je mail."; } })
          .catch(function () { if (gateCodeHint) { gateCodeHint.classList.remove("is-ok"); gateCodeHint.classList.add("is-error"); gateCodeHint.textContent = "Versturen mislukt. Probeer het zo nog eens."; } })
          .then(function () { gateResend.disabled = false; });
      });
    }

    /* ===== Render related products for an episode ===== */
    function renderProducts(v) {
      if (!npProductsGrid) return;
      const list = (v && Array.isArray(v.products)) ? v.products : [];
      if (!list.length) {
        npProductsGrid.innerHTML = "";
        if (npProducts) npProducts.hidden = true;
        return;
      }
      npProductsGrid.innerHTML = list.map(function (p) {
        const url = p.url || "#";
        const img = p.image
          ? '<img src="' + p.image + '" alt="" loading="lazy">'
          : "";
        const atc = p.variantId
          ? '<form action="/cart/add" method="post" class="ep-prod__form">' +
              '<input type="hidden" name="id" value="' + p.variantId + '">' +
              '<button type="submit" class="ep-prod__btn">' +
                '<svg class="ep-prod__btn-ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 9h18l-1.6 10.2a2 2 0 0 1-2 1.8H6.6a2 2 0 0 1-2-1.8L3 9z"></path><path d="M8 9V6a4 4 0 0 1 8 0v3"></path></svg>' +
                'In winkelmandje' +
              '</button>' +
            '</form>'
          : "";
        return (
          '<div class="ep-prod">' +
            '<a class="ep-prod__media" href="' + url + '">' + img + '</a>' +
            '<div class="ep-prod__body">' +
              '<a class="ep-prod__title" href="' + url + '">' + esc(p.title) + '</a>' +
              '<div class="ep-prod__price">' + esc(p.price) + '</div>' +
              atc +
            '</div>' +
          '</div>'
        );
      }).join("");
      if (npProducts) npProducts.hidden = false;
    }

    /* ===== AJAX toevoegen aan winkelmand (blijf op de gids, ga NIET naar checkout) ===== */
    document.addEventListener("submit", function (e) {
      var form = e.target;
      if (!form || !form.classList || !form.classList.contains("ep-prod__form")) return;
      e.preventDefault();
      var btn = form.querySelector(".ep-prod__btn");
      var idInput = form.querySelector('input[name="id"]');
      if (!idInput || !btn || btn.disabled) return;
      var original = btn.innerHTML;
      btn.disabled = true;
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id: idInput.value, quantity: 1 })
      })
        .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
        .then(function () {
          btn.style.setProperty("background", "#2EB849", "important");
          btn.innerHTML =
            '<svg class="ep-prod__btn-ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"></path></svg>Toegevoegd';
          /* laat het thema de winkelmand/teller verversen waar mogelijk */
          try { document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true })); } catch (x) {}
          try { window.dispatchEvent(new Event("cart:updated")); } catch (x) {}
          setTimeout(function () {
            btn.disabled = false;
            btn.style.removeProperty("background");
            btn.innerHTML = original;
          }, 1800);
        })
        .catch(function () { btn.disabled = false; });
    }, false);

    let currentSlug = null;
    let currentTheme = "all";

    function esc(s) {
      return String(s == null ? "" : s)
        .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
    }

    /* ===== Build a single video card ===== */
    function buildCard(v) {
      const card = document.createElement("button");
      const isLocked = GATE.locked(v);
      card.className = "ep-card" + (v.slug === currentSlug ? " is-active" : "") + (isLocked ? " is-locked" : "");
      card.type = "button";
      card.dataset.slug = v.slug;
      card.setAttribute("aria-label", (isLocked ? "Ontgrendel: " : "Speel af: ") + v.title);
      const thumbSrc = v.thumb
        ? v.thumb
        : (v.youtubeId ? "https://i.ytimg.com/vi/" + v.youtubeId + "/hqdefault.jpg" : "");
      const thumbHTML = thumbSrc
        ? '<img src="' + thumbSrc + '" alt="" loading="lazy" onerror="this.style.display=\'none\'">'
        : '<div class="ep-card__thumb-fallback">' +
            '<span class="ep-card__thumb-fallback-mark">Met Jet' + (v.week ? ' · ' + esc(v.week) + ' weken' : '') + '</span>' +
          '</div>';
      const centerHTML = isLocked
        ? '<div class="ep-card__play"></div>' +
          '<div class="ep-card__lock">' +
            '<span class="ep-card__lock-circle"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="4" y="11" width="16" height="9" rx="2"></rect><path d="M8 11V7a4 4 0 0 1 8 0v4"></path></svg></span>' +
            '<span class="ep-card__lock-label">Ontgrendel gratis</span>' +
          '</div>'
        : '<div class="ep-card__play"><span class="ep-card__play-circle">' +
            '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M8 5v14l11-7z"/></svg>' +
          '</span></div>';
      card.innerHTML =
        '<div class="ep-card__thumb">' +
          thumbHTML +
          '<div class="ep-card__overlay">' + String(v.num) + (v.week ? ' · ' + esc(v.week) + ' weken' : '') + '</div>' +
          centerHTML +
          (v.duration ? '<span class="ep-card__duration">' + esc(v.duration) + '</span>' : '') +
        '</div>' +
        '<div class="ep-card__body">' +
          '<h3 class="ep-card__title">' + esc(v.title) + '</h3>' +
          '<p class="ep-card__desc">' + esc(v.desc) + '</p>' +
        '</div>';
      card.addEventListener("click", function () {
        if (GATE.locked(v)) { openGate(v.slug); return; }
        playVideo(v.slug, true);
      });
      return card;
    }

    /* ===== Render leerlijn (grouped per week) ===== */
    function renderLeerlijn() {
      if (!leerlijnEl) return;
      leerlijnEl.innerHTML = "";
      const weeks = Array.from(new Set(VIDEOS.map(v => v.week))).sort((a, b) => a - b);
      weeks.forEach(function (week) {
        const row = document.createElement("div");
        row.className = "ep-week-row";
        const wkVideos = VIDEOS.filter(v => v.week === week);
        const pair = WEEK_LABELS[week] || [week + " weken", ""];
        row.innerHTML =
          '<div class="ep-week-row__head">' +
            '<div class="ep-week-row__num">' + esc(week) + '<small>WEKEN</small></div>' +
            '<div><h3 class="ep-week-row__title">' + esc(pair[0]) + '</h3>' +
            '<p class="ep-week-row__sub">' + esc(pair[1]) + '</p></div>' +
          '</div>' +
          '<div class="ep-week-row__videos"></div>';
        const videosEl = row.querySelector(".ep-week-row__videos");
        wkVideos.forEach(v => videosEl.appendChild(buildCard(v)));
        leerlijnEl.appendChild(row);
      });
    }

    /* ===== Render grid ===== */
    function renderGrid() {
      if (!grid) return;
      grid.innerHTML = "";
      const filtered = VIDEOS.filter(v => currentTheme === "all" || v.theme === currentTheme);
      filtered.forEach(v => grid.appendChild(buildCard(v)));
      if (filtered.length === 0) {
        grid.innerHTML = '<div style="grid-column:1/-1;text-align:center;padding:3rem 1rem;color:var(--ep-text-light);font-family:var(--ep-font-sub);">Geen afleveringen in dit thema (yet).</div>';
      }
    }

    /* ===== Play a video ===== */
    function playVideo(slug, scroll) {
      const v = VIDEOS.find(x => x.slug === slug);
      if (!v) return;
      if (GATE.locked(v)) { openGate(slug); return; }
      currentSlug = slug;

      if (playerFrame) {
        if (v.youtubeId) {
          const origin = encodeURIComponent(window.location.origin);
          playerFrame.innerHTML =
            '<iframe src="https://www.youtube.com/embed/' + v.youtubeId +
            '?autoplay=1&rel=0&modestbranding=1&playsinline=1&origin=' + origin +
            '" title="' + esc(v.title) + '" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>';
        } else {
          playerFrame.innerHTML =
            '<div class="ep-player__placeholder" style="gap:0.8rem;">' +
              '<div style="width:84px;height:84px;border-radius:50%;background:rgba(255,255,255,0.95);color:var(--ep-energiek);display:grid;place-items:center;box-shadow:0 12px 30px rgba(0,0,0,0.3);">' +
                '<svg viewBox="0 0 24 24" fill="currentColor" style="width:32px;height:32px;margin-left:4px;"><path d="M8 5v14l11-7z"/></svg>' +
              '</div>' +
              '<p style="font-family:var(--ep-font-heading);font-size:1.4rem;color:#fff;margin:0;line-height:1.15;max-width:280px;">' + esc(v.title) + '</p>' +
              '<p style="font-family:var(--ep-font-sub);font-size:0.85rem;opacity:0.7;color:#fff;margin:0;">Aflevering ' + esc(v.num) + ' · ' + esc(v.week) + ' weken · ' + esc(v.duration) + '</p>' +
            '</div>';
        }
      }

      if (npStepNum) npStepNum.textContent = String(v.num);
      if (npStepLabel) npStepLabel.textContent = "Aflevering" + (v.week ? " · " + v.week + " weken" : "");
      if (npTitle) npTitle.textContent = v.title;
      if (npDesc) npDesc.textContent = v.desc;
      if (npChips) {
        var chips = "";
        if (v.week) chips += '<span class="ep-chip ep-chip--week">📅 ' + esc(v.week) + ' weken</span>';
        if (v.duration) chips += '<span class="ep-chip">⏱ ' + esc(v.duration) + '</span>';
        if (v.themeLabel) chips += '<span class="ep-chip">' + esc(v.themeLabel) + '</span>';
        npChips.innerHTML = chips;
      }
      renderProducts(v);

      const url = new URL(window.location.href);
      url.searchParams.set("v", slug);
      history.replaceState({}, "", url);

      $$(".ep-card").forEach(c => c.classList.toggle("is-active", c.dataset.slug === slug));
      updateShareTargets();

      if (scroll) {
        const fp = document.getElementById("featured-player");
        if (fp) fp.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }

    /* ===== Share targets ===== */
    function updateShareTargets() {
      const url = new URL(window.location.href);
      if (currentSlug) url.searchParams.set("v", currentSlug);
      const u = url.toString();
      const v = VIDEOS.find(x => x.slug === currentSlug);
      const msg = v
        ? 'Easy Puppy Gids met Jet, "' + v.title + '". Gratis tips voor pups van 8-12 weken: ' + u
        : "Easy Puppy Gids met Jet, gratis tips voor pups van 8-12 weken: " + u;
      const wa = $("#share-whatsapp"); if (wa) wa.href = "https://wa.me/?text=" + encodeURIComponent(msg);
      const fb = $("#share-fb"); if (fb) fb.href = "https://www.facebook.com/sharer/sharer.php?u=" + encodeURIComponent(u);
      const ml = $("#share-mail"); if (ml) ml.href = "mailto:?subject=" + encodeURIComponent("Easy Puppy Gids, voor jouw pup") + "&body=" + encodeURIComponent(msg);
    }

    /* ===== Copy share link ===== */
    async function copyLink(btn, label, fallback) {
      const url = new URL(window.location.href);
      if (currentSlug) url.searchParams.set("v", currentSlug);
      try {
        await navigator.clipboard.writeText(url.toString());
        if (label) label.textContent = "Gekopieerd!";
        btn.classList.add("is-copied");
        setTimeout(function () {
          if (label) label.textContent = fallback;
          btn.classList.remove("is-copied");
        }, 1800);
      } catch (e) {
        window.prompt("Kopieer deze link:", url.toString());
      }
    }
    const shareCopy = $("#share-copy");
    if (shareCopy) shareCopy.addEventListener("click", e => copyLink(e.currentTarget, $("#share-copy-label"), "Link kopiëren"));
    // Kleine toast-melding
    function epToast(text) {
      var t = document.createElement("div");
      t.textContent = text;
      t.style.cssText = "position:fixed;left:50%;bottom:24px;transform:translateX(-50%);background:#421469;color:#fff;font-family:var(--ep-font-sub,sans-serif);font-weight:700;font-size:0.9rem;padding:0.7rem 1.2rem;border-radius:999px;box-shadow:0 10px 30px rgba(0,0,0,0.25);z-index:99999;opacity:0;transition:opacity .2s ease;";
      document.body.appendChild(t);
      requestAnimationFrame(function () { t.style.opacity = "1"; });
      setTimeout(function () { t.style.opacity = "0"; setTimeout(function () { t.remove(); }, 260); }, 2200);
    }
    // Instagram kan geen link voorinvullen: kopieer de link (met melding) en open Instagram DM, zodat ze 'm kunnen plakken.
    const shareIg = $("#share-instagram");
    if (shareIg) shareIg.addEventListener("click", function () {
      var url = new URL(window.location.href);
      if (currentSlug) url.searchParams.set("v", currentSlug);
      try { if (navigator.clipboard) navigator.clipboard.writeText(url.toString()); } catch (e) {}
      epToast("Link gekopieerd naar je klembord");
    });
    const stickyShare = $("#sticky-share");
    if (stickyShare) stickyShare.addEventListener("click", e => copyLink(e.currentTarget, $("#sticky-share-label"), "Deel de gids"));

    /* ===== Placeholder play (no video selected yet) ===== */
    const placeholderPlay = $("#placeholder-play");
    if (placeholderPlay && VIDEOS.length) {
      placeholderPlay.addEventListener("click", () => playVideo(VIDEOS[0].slug, false));
    }

    /* ===== Theme filters ===== */
    $$("#theme-filters .ep-filter-btn").forEach(function (btn) {
      btn.addEventListener("click", function () {
        $$("#theme-filters .ep-filter-btn").forEach(b => b.classList.remove("is-active"));
        btn.classList.add("is-active");
        currentTheme = btn.dataset.theme;
        renderGrid();
      });
    });

    /* ===== Opt-in form (onderaan de gids) — start dezelfde code-flow ===== */
    const optinForm = $("#optin-form");
    if (optinForm) {
      optinForm.addEventListener("submit", function (e) {
        e.preventDefault();
        const input = optinForm.querySelector('input[type="email"]');
        const btn = optinForm.querySelector('button[type="submit"]');
        const email = input ? (input.value || "").trim() : "";
        if (!email || (input && !input.checkValidity())) { if (input) input.focus(); return; }
        startCodeFlow(email, { props: gateProps({ pet: "puppy" }), source: "Puppy gids opt-in blok", slug: null }, btn)
          .catch(function () { console.warn("[ep-gids] code-flow (opt-in blok) mislukt"); });
      });
    }

    /* ===== Pet sign-up (verplichte type-keuze) ===== */
    (function () {
      const STAGES = {
        hond: ["Puppy", "Kleine hond", "Middelgrote hond", "Grote hond"],
        kat:  ["Kitten", "Volwassen kat", "Senior kat"]
      };
      const SPECIES_LABEL = { hond: "Wat voor hond?", kat: "Wat voor kat?" };
      const form = $("#petsignup-form");
      if (!form) return;
      const card = form;
      const speciesSeg = $("#ps-species");
      const stagesEl = $("#ps-stages");
      const step2 = $("#ps-step2");
      const step2Label = $("#ps-step2-label");
      const step3 = $("#ps-step3");
      const emailInput = $("#ps-email");
      const submitBtn = $("#ps-submit");
      const hint = $("#ps-hint");

      let species = null;
      let stage = null;

      function refreshSubmit() {
        const ready2 = species && stage;
        submitBtn.disabled = !ready2;
        if (ready2) {
          step3.classList.remove("ep-petstep--locked");
          hint.classList.remove("is-error");
          hint.textContent = "Eén mail af en toe, met tips op maat. Uitschrijven kan altijd.";
        }
      }
      function step1Done() { $("#ps-step1").classList.add("ep-petstep--done"); }
      function pickStage(chip, label) {
        stage = label;
        stagesEl.querySelectorAll(".ep-typechip").forEach(c => c.classList.remove("is-on"));
        chip.classList.add("is-on");
        step2.classList.add("ep-petstep--done");
        refreshSubmit();
      }
      function pickSpecies(value) {
        species = value;
        stage = null;
        speciesSeg.querySelectorAll("button").forEach(b => b.classList.toggle("is-on", b.dataset.species === value));
        step2.classList.remove("ep-petstep--locked");
        step2Label.textContent = SPECIES_LABEL[value];
        stagesEl.innerHTML = "";
        STAGES[value].forEach(function (label) {
          const chip = document.createElement("button");
          chip.type = "button";
          chip.className = "ep-typechip";
          chip.textContent = label;
          chip.addEventListener("click", () => pickStage(chip, label));
          stagesEl.appendChild(chip);
        });
        stagesEl.hidden = false;
        step1Done();
        step3.classList.add("ep-petstep--locked");
        refreshSubmit();
      }

      speciesSeg.querySelectorAll("button").forEach(btn =>
        btn.addEventListener("click", () => pickSpecies(btn.dataset.species)));

      form.addEventListener("submit", function (e) {
        e.preventDefault();
        if (!species || !stage) {
          hint.classList.add("is-error");
          hint.textContent = "Kies eerst hond of kat én het type, dan kun je je aanmelden.";
          card.classList.remove("shake");
          void card.offsetWidth;
          card.classList.add("shake");
          return;
        }
        if (!emailInput.value || !emailInput.checkValidity()) {
          emailInput.focus();
          hint.classList.add("is-error");
          hint.textContent = "Vul nog even een geldig e-mailadres in.";
          return;
        }
        const email = (emailInput.value || "").trim();
        const gateList = (GATE.cfg && GATE.cfg.lists.length) ? [GATE.cfg.lists[0]] : null;
        startCodeFlow(email, {
          props: Object.assign({ pet_species: species, pet_stage: stage }, (species === "hond" && stage === "Puppy") ? { "Heeft puppy": "yes" } : {}),
          source: "Puppy gids pet sign-up",
          lists: gateList,
          slug: null
        }, submitBtn).catch(function () {
          if (hint) { hint.classList.add("is-error"); hint.textContent = "Kon de code niet versturen. Probeer het zo nog eens."; }
        });
      });
    })();

    /* ===== Deep link (?v=slug) ===== */
    function resolveDeepLink() {
      const url = new URL(window.location.href);
      const slug = url.searchParams.get("v") || (url.hash || "").replace("#", "");
      if (slug && VIDEOS.find(v => v.slug === slug)) playVideo(slug, false);
      else updateShareTargets();
    }

    /* ===== Init ===== */
    renderLeerlijn();
    renderGrid();
    resolveDeepLink();
    if (!currentSlug && VIDEOS.length) renderProducts(VIDEOS[0]);
    window.addEventListener("popstate", resolveDeepLink);
  });
})();
